import React, { useEffect, useState } from "react";
import { Image, Input, message, Tag, Upload } from "antd";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";

import plus from "../../assets/svg/plus_white.svg";
import chart from "../../assets/svg/chart.svg";
import location from "../../assets/svg/locationDark.svg";
import time from "../../assets/svg/TimeCircle.svg";
import send from "../../assets/svg/send.svg";
import caret from "../../assets/svg/caret_right.png";
import { btnStyle, inputStyle } from "../../lib/styles/styleLibrary";
import Auth from "../../lib/middleware/auth";
import { useMutation } from "react-query";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import errorHandler from "../../redux/actions/errorHandler";
import { saveWeddingInvite } from "../../redux/actions/wedding";
import { Loading } from "..";
import dayjs from "dayjs";
import { DownloadOutlined } from "@ant-design/icons";
import guestlist from "../../assets/shared/GuestList.csv";

const Wrapper = styled.div`
	${tw`p-2`}

	@media (max-width: 1217px) {
		${({ hide }) => hide && `display: none;`};
	}

	.ant-picker-input > input {
		padding-left: 0px !important;
	}

	.btnStyle {
		font-size: 0.75rem;
		font-family: "Poppins";
		border: "1px solid #f4f4f8" !important;
	}

	.delBg {
		${tw`h-9 w-9`}
		background: rgb(255, 255, 255, 0.6);
		/* border: 1px solid #ffffff; */
		box-sizing: border-box;
		border-radius: 50%;
	}
	#guest-list {
		&::placeholder {
			color: red;
			opacity: 0.6; /* Firefox */
		}
	}
	#color-picker-tool {
		background: conic-gradient(
			from 180deg at 50% 50%,
			#f15e5f 0deg,
			#ff9249 54.38deg,
			#ffb800 112.5deg,
			#00b6aa 172.5deg,
			#1877f2 240deg,
			#9895ee 316.87deg,
			#f15e5f 360deg
		);
	}
	.ant-radio-button-wrapper:not(:first-child)::before {
		display: none;
	}
	.active {
		${tw`text-appPink! text-xs font-medium shadow`}
		background: rgb(250, 115, 139, 0.2);
		font-family: Poppins;
		line-height: 12px;
		letter-spacing: 0.5px;
	}
	.inactive {
		${tw`text-appTextFaded! text-xs font-medium shadow`}
		background: rgb(175, 178, 181, 0.2);
		font-family: Poppins;
		font-style: normal;
		font-weight: 500;
		/* font-size: 12px; */
		line-height: 12px;
		/* identical to box height, or 100% */
		letter-spacing: 0.5px;
		/* Dark */
		color: #32323284;
	}
`;

const Invite = (props) => {
	const { TextArea } = Input;
	const couple = Auth.getCouple();
	// console.log(couple);
	const [fields, setFields] = useState({
		useGuestList: false,
		firstname: "",
		lastname: "",
		email: "",
		section: "",
		short_note: `You are cordially invited... \n\n #${couple?.hashtag}`,
		editWeddingDetails: false,
		should_send: true,
	});

	// Upload Cover Photo
	const [defaultFileList, setDefaultFileList] = useState([]);
	const [showupload, setShowUpload] = useState(true);

	useEffect(() => {
		isEmpty(defaultFileList)
			? setFields({ ...fields, useGuestList: false })
			: setFields({ ...fields, useGuestList: true });
		// eslint-disable-next-line
	}, [defaultFileList]);

	const handleFileChange = (info) => {
		// Processing file Change, guaranteed that the user selected by one is only one
		setDefaultFileList(info.fileList);
	};

	const handleBeforeUpload = () => {
		setFields({ ...fields, useGuestList: true });
		return true;
	};

	const { mutateAsync: saveInvite, isLoading: inviteloading } =
		useMutation(saveWeddingInvite);

	// console.log(defaultFileList, "Default file list \n", fields.useGuestList);
	const handleSave = async (options) => {
		const { file } = options;

		console.log("\n on log\n", defaultFileList, file);

		if (fields.useGuestList) {
			if (isEmpty(defaultFileList)) {
				message.warning("Please select the file you wish to upload");
				return;
			}
		} else {
			if (isEmpty(fields.firstname.trim())) {
				Toast.fire({
					icon: "error",
					title: `First name field is required`,
				});
				return;
			}
			if (isEmpty(fields.lastname.trim())) {
				Toast.fire({
					icon: "error",
					title: `Last name field is required`,
				});
				return;
			}
			if (isEmpty(fields.email.trim())) {
				Toast.fire({
					icon: "error",
					title: `Email is required`,
				});
				return;
			}
			if (isEmpty(fields.section)) {
				Toast.fire({
					icon: "error",
					title: `Select guest type for the event,\n Bride's or Groom's`,
				});
				return;
			}
		}

		const formData = new FormData();
		const config = {
			headers: { "content-type": "multipart/form-data" },
		};

		formData.append("guest_list", file);
		const data = { ...fields, ...formData };

		console.log(formData, data);

		try {
			const res = await saveInvite(data, config);
			console.log(res);
			const { hasError } = res.data;
			if (hasError) {
				return Toast.fire({
					icon: "error",
					title: res.data.errors.message,
				});
			}
			Toast.fire({
				icon: "success",
				title: "Invite has been processed successfully",
			});

			setFields({
				useGuestList: false,
				firstname: "",
				lastname: "",
				email: "",
				section: "",
				short_note: `You are cordially invited... \n\n #${couple?.hashtag}`,
				editWeddingDetails: false,
				should_send: true,
			});
			setDefaultFileList([]);
			setShowUpload(false);
			props.refetch && props.refetch();
		} catch (error) {
			errorHandler(error);
		}
	};

	return (
		<Wrapper hide={props.hideOnMobile}>
			<h3 tw="font-semibold tracking-wider" style={{ fontSize: "15px" }}>
				Invite guest
			</h3>

			<div tw="w-full flex flex-col gap-1 mt-4">
				<Input
					placeholder="First Name"
					type="text"
					value={fields.firstname}
					onChange={(e) =>
						setFields({ ...fields, firstname: e.target.value })
					}
					css={inputStyle}
					tw="w-full text-xs! rounded-md"
				/>
				<Input
					placeholder="Last Name"
					type="text"
					value={fields.lastname}
					onChange={(e) =>
						setFields({ ...fields, lastname: e.target.value })
					}
					css={inputStyle}
					tw="w-full text-xs! rounded-md"
				/>
				<Input
					placeholder="Enter email address"
					type="email"
					css={inputStyle}
					value={fields.email}
					onChange={(e) =>
						setFields({ ...fields, email: e.target.value })
					}
					tw="w-full text-xs! rounded-md"
				/>
				<TextArea
					placeholder="Short note"
					value={fields.short_note}
					rows={10}
					onChange={(e) =>
						setFields({ ...fields, short_note: e.target.value })
					}
					tw="mb-4 text-xs! h-full! p-4 rounded! box-border"
					css={inputStyle}
				/>
			</div>

			<div tw=" flex flex-row flex-wrap items-center justify-center gap-6">
				<button
					size="large"
					value="bride"
					tw="rounded-3xl! border-none px-5 py-3"
					className={
						fields.section === "bride" ? "active" : "inactive"
					}
					onClick={(e) => {
						setFields({ ...fields, section: e.target.value });
					}}>
					Bride’s guest
				</button>
				<button
					size="large"
					value="groom"
					tw="rounded-3xl! border-none px-5 py-3"
					className={
						fields.section === "groom" ? "active" : "inactive"
					}
					onClick={(e) => {
						setFields({ ...fields, section: e.target.value });
					}}>
					Groom’s guest
				</button>
			</div>

			<div tw="mt-8">
				<hr
					tw="mb-4 opacity-50"
					style={{ border: "1px solid #ECECEC" }}
				/>
				<div tw="flex flex-row flex-nowrap items-center justify-between">
					{" "}
					<span tw="inline-flex flex-nowrap gap-4 items-center">
						<Image
							preview={false}
							src={location}
							alt=""
							width={14}
							height={20}
						/>{" "}
						<span tw="text-sm tracking-wider">Venue</span>{" "}
					</span>
					<span tw="text-appPink opacity-50 inline-flex items-center gap-2">
						<span tw="text-sm">Edit</span>{" "}
						<Image
							preview={false}
							src={caret}
							alt=""
							width={6}
							height={9}
						/>{" "}
					</span>
				</div>

				<p tw="opacity-50 pt-4 pb-2">
					{couple?.venue}
					{" \n"}
					{couple?.venue_description}
				</p>
				<hr
					tw="mb-4 opacity-50"
					style={{ border: "1px solid #ECECEC" }}
				/>
				<div tw="flex flex-row flex-nowrap items-center justify-between">
					{" "}
					<span tw="inline-flex flex-nowrap gap-3 items-center">
						<Image
							preview={false}
							src={time}
							alt=""
							width={20}
							height={20}
						/>{" "}
						<span tw="text-sm tracking-wider">Time</span>{" "}
					</span>
					<span tw="text-appPink opacity-50 inline-flex items-center gap-2">
						<span tw="text-sm">Edit</span>{" "}
						<Image
							preview={false}
							src={caret}
							alt=""
							width={6}
							height={9}
						/>{" "}
					</span>
				</div>
				<p tw="opacity-50 pt-4 pb-2">
					{dayjs(couple?.date).format("DD-MM-YYYY -> hh:mm a ")}
				</p>
			</div>

			<div tw="mt-2 flex flex-col gap-2 items-center justify-center">
				<Upload
					defaultFileList={defaultFileList}
					accept=".csv"
					onChange={handleFileChange}
					beforeUpload={handleBeforeUpload}
					customRequest={handleSave}
					maxCount={1}
					showUploadList={showupload}>
					{defaultFileList.length >= 1 ? null : (
						<button tw="text-appPink flex flex-row flex-nowrap items-center justify-between bg-transparent! border-none w-full px-1 py-3">
							<Image
								preview={false}
								src={chart}
								alt=""
								width={25}
								height={25}
								tw="pr-2"
							/>{" "}
							<span>Upload guest list (optional)</span>
							<Image
								preview={false}
								src={plus}
								alt=""
								width={25}
								height={25}
								tw="pl-2"
							/>
						</button>
					)}
				</Upload>

				<Tag icon={<DownloadOutlined />} color="yellow">
					<a href={guestlist} download>
						{" "}
						Download sample guest list
					</a>
				</Tag>
			</div>

			<div tw="pt-8 mb-12 flex flex-col gap-2 items-center justify-center w-full">
				<button
					css={btnStyle}
					onClick={(e) => {
						setFields({ ...fields, should_send: false });
						setTimeout(() => {
							handleSave(e);
						}, 500);
					}}
					tw="inline-flex bg-transparent! text-appPink hover:(bg-appLightPink! shadow-md) gap-2 items-center justify-center">
					{inviteloading ? (
						<Loading />
					) : (
						<>
							<span>Save</span>
							<Image
								preview={false}
								src={send}
								alt=""
								width={15}
								height={15}
							/>
						</>
					)}
				</button>

				<button
					css={btnStyle}
					onClick={(e) => {
						handleSave(e);
					}}
					tw="inline-flex gap-2 hover:(bg-appPinkSaturated! text-white shadow-lg) items-center justify-center">
					{inviteloading && fields.should_send ? (
						<Loading />
					) : (
						<>
							<span>Save and send invite</span>
							<Image
								preview={false}
								src={send}
								alt=""
								width={15}
								height={15}
							/>
						</>
					)}
				</button>
			</div>
		</Wrapper>
	);
};

export default Invite;
